import React, { useRef, useState } from "react";

const FileUploader = ({
  multiple,
  maxSizeMB,
  accept = ".pdf,.jpg,.png",
  onFileSelectSuccess,
  onFileSelectError,
}) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const [selectedFiles, setSelectedFiles] = useState<any[]>([]);

  const handleFiles = (files) => {
    console.info("FILE INPUT");
    let error = "";
    const maxFileSize = maxSizeMB * 1024 * 1024;

    if (multiple) {
      Array.from<File>(files).forEach((file) => {
        if (file.size > maxFileSize) {
          error += `${file.name} no puede exceder los ${maxSizeMB}MB.`;
        }
      });
    } else {
      if (files.length > 1) {
        error = "Solo se permite un archivo.";
      } else if (files[0].size > maxFileSize) {
        error = `El archivo no puede exceder los ${maxSizeMB}MB.`;
      }
    }

    if (error) {
      onFileSelectError({
        error: error,
      });
    } else {
      setSelectedFiles(Array.from(files));
      onFileSelectSuccess(Array.from(files));
    }
  };

  // drag state
  const [dragActive, setDragActive] = React.useState(false);

  // handle drag events
  const handleDrag = function (e) {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
    } else if (e.type === "dragleave") {
      setDragActive(false);
    }
  };

  // triggers when file is dropped
  const handleDrop = function (e) {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      handleFiles(e.dataTransfer.files);
    }
  };

  // triggers when file is selected with click
  const handleChange = function (e) {
    e.preventDefault();
    if (e.target.files && e.target.files[0]) {
      handleFiles(e.target.files);
    }
  };

  function removeFile(index) {
    const tempSelFiles = [...selectedFiles];
    tempSelFiles.splice(index, 1);
    setSelectedFiles(tempSelFiles);
    onFileSelectSuccess(tempSelFiles);
    if(!tempSelFiles.length){
      inputRef.current!.value = '';
    }
  }

  return (
    <>
      <div className="accordion-container">
        <div className="accordion-item">
          <div className="content-accordion">
            <div className="description">
              <div className="info-upload">
                <div className="icon-container">
                  <i className="icon icon-info"></i>
                </div>
                <p>
                  Solo se aceptan archivos en{" "}
                  <b>
                    {accept} <br className="hidden md:block" />
                    Máximo {maxSizeMB}MB por archivo.
                  </b>
                </p>
              </div>
              <div
                className="py-2"
                onDragEnter={handleDrag}
              >
                <div className="form-group">
                  <div className="custom-file">
                    <input
                      type="file"
                      className="custom-file-input"
                      accept={accept}
                      multiple={multiple}
                      onChange={handleChange}
                      ref={inputRef}
                    />

                    <div
                      className={`file-description${
                        dragActive ? " drag-active" : ""
                      }`}
                    >
                      <i className="icon icon-upload"></i>
                      <label id="nameFile" className="custom-file-label">
                        Subir Archivo
                      </label>
                    </div>
                  </div>
                </div>
                {dragActive && (
                  <div
                    id="drag-file-element"
                    onDragEnter={handleDrag}
                    onDragLeave={handleDrag}
                    onDragOver={handleDrag}
                    onDrop={handleDrop}
                  ></div>
                )}
              </div>
              {selectedFiles.length > 0 && (
                <div className="block space-y-4">
                  <h5 className="text-body-1 text-neutral-black font-body font-semibold">
                    Archivos Cargados
                  </h5>
                  {selectedFiles.map((file, index) => {
                    return (
                      <div className="btn-download" key={index}>
                        <div className="flex items-center pr-2">
                          <div className="icon-container">
                            <i className="icon icon-file"></i>
                          </div>
                          <h5 className="text-body-1 text-gray-80 font-body font-semibold pl-4">
                            {file.name}
                          </h5>
                        </div>
                        <button
                          onClick={() => {
                            removeFile(index);
                          }}
                          className="text-[16px] text-gray-50"
                        >
                          <i className="icon icon-close"></i>
                        </button>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FileUploader;
